export enum Documents {
  Document = 'Ważne dokumenty',
  DownloadOWUAndProductCard = 'Pobierz OWU z Kartą produktu',
  GeneralRegulationsOfCompetitionsAndPromotions = 'Ogólny regulamin konkursów i promocji',
  PrivacyPolicy = 'Polityka prywatności',
  RegulationsOfSkpContest = 'Regulamin konkursu SKP',
  WebsiteRegulations = 'Regulamin serwisu',
}
